module.exports = __webpack_public_path__ + "img/rent_camper_1.f5da3ca6.jpg";